export const PHOTO_CAROUSEL_ADMIN_VIEW_STORAGE_KEY = 'hs.admin.submissionsView';

export type PhotoCarouselAdminView = 'cards' | 'list';

export function parsePhotoCarouselAdminView(
  raw: string | null | undefined,
): PhotoCarouselAdminView {
  return raw === 'list' ? 'list' : 'cards';
}

export function readPhotoCarouselAdminView(storage: {
  getItem: (key: string) => string | null;
}): PhotoCarouselAdminView {
  return parsePhotoCarouselAdminView(
    storage.getItem(PHOTO_CAROUSEL_ADMIN_VIEW_STORAGE_KEY),
  );
}

export function writePhotoCarouselAdminView(
  storage: { setItem: (key: string, value: string) => void },
  view: PhotoCarouselAdminView,
): void {
  storage.setItem(PHOTO_CAROUSEL_ADMIN_VIEW_STORAGE_KEY, view);
}
